// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import weui from 'weui.js'
import 'weui'
import http from './utils/axios'
import util from "./utils/utils"
import router from './router'
import App from './App'


Vue.config.productionTip = false
Vue.prototype.$axios=http;
Vue.prototype.$util=util;
Vue.prototype.$weui = weui

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js